import * as React from "react";
import {RecurringExpenseStore} from "../stores/recurring_expense";

export const RecurringExpenseStoreContext = React.createContext<RecurringExpenseStore | null>(null);
